import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import PageLayout from '../../components/Layout/PageLayout/PageLayout';
import { MainTitleStyled } from '../../components/Layout/PageLayout/PageLayout.styled';
import { useCommon } from '../../context/CommonContext';
import { RoutesPathE } from '../../declarations/enums/routes';
import useReactRouter from '../../hooks/useReactRouter';
import TransportationForm from './components/TransportationForm/TransportationForm';

const TransportationPage = () => {
  const { navigateTo } = useReactRouter();
  const { isTransportDashboardType } = useCommon();

  const [isTriggeredBreadcrumbs, setTriggeredBreadcrumbs] = useState(false);

  return (
    <>
      <PageLayout
        onClickBack={() => navigateTo(RoutesPathE.HOME_PAGE)}
        onClickBreadcrumb={() => setTriggeredBreadcrumbs(!isTriggeredBreadcrumbs)}
        backButtonLabel={<FormattedMessage id="button.backToHome" defaultMessage="Back to home" />}
        topSectionContent={
          <>
            <MainTitleStyled level={2}>
              <FormattedMessage
                id="breadcrumbs.yourTransportation"
                defaultMessage="Your Transportation"
              />
            </MainTitleStyled>

            <p>
              <FormattedMessage
                id="trip.form.subLabel"
                defaultMessage="Calculate the carbon emissions generated by your travel."
              />
            </p>

            <p>
              {isTransportDashboardType ? (
                <FormattedMessage
                  id="getting.destination"
                  defaultMessage="How are you getting to your destination?"
                />
              ) : (
                <FormattedMessage
                  id="getting.hotel"
                  defaultMessage="How are you getting to the hotel?"
                />
              )}
            </p>
          </>
        }
        leftSideContent={<TransportationForm isTriggeredBreadcrumbs={isTriggeredBreadcrumbs} />}
      />
    </>
  );
};

export default TransportationPage;
